export const admin = user => user && user.role === 'ROLE_ADMIN';
export const office = user => user && user.role === 'ROLE_OFFICE';
export const base = user => user && user.role === 'ROLE_DEFAULT';
export const isSuper = user => admin(user) || office(user);
